import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import ReactTable from 'react-table'
import "react-table/react-table.css";

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';



class QuotationDUser extends Component {

    constructor(){
        super();
        this.view = this.view.bind(this)
        this.state = {
            user :{},
            quotation: {},
            userId :{}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId : data.key,
                        user:data.val()
                      })


                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        });   
    }

    componentDidUpdate(prevProps,prevState){
        if(prevState.userId !== this.state.userId){
            console.log(this.state.userId)
            let quotation = ref.child("Quotation").orderByChild("userId").equalTo(this.state.userId);
            quotation.on("value", function(snap){
                this.setState({
                    quotation : snap.val()
                })
            }.bind(this))
        }
    }

    view(index){
        window.location.assign("/quotation/"+index+"/edit")
    }

    render() {
        var x = [];
        this.state.quotation &&
        Object.keys(this.state.quotation).map(key => {
            let list = this.state.quotation[key]
                if(list.status ==="Disapproved"){
                    list.id = key
                    list.customer.name = list.customer.name.toUpperCase();
                    list.customer.location = list.customer.location.toUpperCase();
                    list.customer.representative = list.customer.representative.toUpperCase();
                    list.status = list.status.toUpperCase();
                    x.push(list)
                }
            }) 
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Disapproved Quotation" />
                            <div className="block">
                                <ReactTable
                                    data={x}
                                    columns={[
                                        {
                                            Header: "Quotation Number",
                                            accessor : "id"
                                        },
                                        {
                                            Header: "Customer Name",
                                            accessor : "customer.name",
                                            filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: "Address",
                                            accessor : "customer.location",
                                            filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: "Sales Representative",
                                            accessor : "customer.representative",filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: "Status",
                                            accessor : "status",filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: 'Action',
                                            accessor : "id",
                                            Cell : row => (
                                                <span>
                                                <button onClick={()=>this.view(row.value)}><i className="fa fa-eye"></i></button>                                                
                                                </span>
                                            )
                                                                               
                                        }
                                    ]}
                                    
                                    filterable ={true}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />     
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default QuotationDUser;



// WEBPACK FOOTER //
// ./src/components/QuotationDUser.js